import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';

const SpinnerSvg = ({ className }: { className: string }) => (
  <svg className={className} width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
  </svg>
);

const offset = 187;
const offsetDash = offset / 6;
const duration = '1.4s';

const Spinner = styled(SpinnerSvg)<{ inline?: boolean }>`
  display: inline-block;
  height: 1em;
  width: auto;

  ${({ inline }) =>
    inline &&
    css`
      vertical-align: -0.11em;
    `}

  animation: rotator ${duration} linear infinite;
  @keyframes rotator {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(270deg);
    }
  }

  circle {
    stroke-dasharray: ${offset};
    stroke-dashoffset: 0;
    transform-origin: center;
    ${({ theme, inline }) =>
      inline
        ? css`
            animation: dash ${duration} ease-in-out infinite;
            stroke: currentColor;
          `
        : css`
            animation: dash ${duration} ease-in-out infinite, colors calc(${duration} * 2) ease-in-out infinite;
            @keyframes colors {
              0% {
                stroke: ${theme.color.muted};
              }
              50% {
                stroke: ${theme.color.accent};
              }
              100% {
                stroke: ${theme.color.muted};
              }
            }
          `}

    @keyframes dash {
      0% {
        stroke-dashoffset: ${offset};
      }
      50% {
        stroke-dashoffset: ${offsetDash};
        transform: rotate(135deg);
      }
      100% {
        stroke-dashoffset: ${offset};
        transform: rotate(450deg);
      }
    }
  }
`;

const LoadingIndicator = ({ delay = 500, className }: { delay?: number; className?: string }) => {
  const [pastDelay, setPastDelay] = useState(delay === 0);
  useEffect(() => {
    if (delay > 0) {
      const delayTimeout = window.setTimeout(() => setPastDelay(true), delay);
      return () => clearTimeout(delayTimeout);
    }
    return undefined;
  }, []);
  return pastDelay ? <Spinner className={className} /> : <></>;
};

const LoadingIndicatorInline = ({ className }: { className?: string }) => <Spinner inline className={className} />;

export { LoadingIndicatorInline };
export default LoadingIndicator;
